"use client";

import { c as _c } from "react/compiler-runtime";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@defuse/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@defuse/ui/dropdown-menu";
export function ModeToggle() {
  const $ = _c(11);
  const {
    setTheme
  } = useTheme();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DropdownMenuTrigger asChild={true}><Button variant="outline" size="icon"><Sun className="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" /><Moon className="absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" /><span className="sr-only">Toggle theme</span></Button></DropdownMenuTrigger>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== setTheme) {
    t1 = <DropdownMenuItem onClick={() => {
      setTheme("light");
    }}>Light</DropdownMenuItem>;
    $[1] = setTheme;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== setTheme) {
    t2 = <DropdownMenuItem onClick={() => {
      setTheme("dark");
    }}>Dark</DropdownMenuItem>;
    $[3] = setTheme;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== setTheme) {
    t3 = <DropdownMenuItem onClick={() => {
      setTheme("system");
    }}>System</DropdownMenuItem>;
    $[5] = setTheme;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <DropdownMenu>{t0}<DropdownMenuContent align="end">{t1}{t2}{t3}</DropdownMenuContent></DropdownMenu>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}